import {
  Component,
  computed,
  inject,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, RouterModule, RouterOutlet} from '@angular/router';
import {
  APP_MENU_BACK_TO_PREVIOUS_TITLE_TOKEN,
  APP_MENU_CONFIG_TOKEN,
  APP_NAME_TOKEN,
  APP_TOOLBAR_CONFIG_TOKEN,
  PORTAL_BAR_TITLE_TOKEN,
} from '../../epg-modern-layout-config.constant';
import {routePageAnimationLeftToRightAnimation} from './route-animation';
import {
  EpgDownloadCenterService,
  EpgDownloadService,
} from '@epg-apps/epg-download';
import {EpgToolbarComponent} from '@epg-apps/epg-toolbar';

@Component({
  standalone: true,
  imports: [RouterModule, EpgToolbarComponent],
  templateUrl: './epg-modern-layout.component.html',
  styleUrl: './epg-modern-layout.component.scss',
  animations: [routePageAnimationLeftToRightAnimation],
  encapsulation: ViewEncapsulation.None,
})
export class EpgModernLayoutComponent {
  @Input() navigateToPreviousPage?: string;
  @Input() navigateToPreviousLabel?: string;

  // Toolbar Config
  toolbarConfig = inject(APP_TOOLBAR_CONFIG_TOKEN, {optional: true});
  // Portalbar Config
  portalBarTitle = inject(PORTAL_BAR_TITLE_TOKEN, {optional: true}) || '';
  // Injectable application name
  applicationName = inject(APP_NAME_TOKEN, {optional: true});

  // TODO: Create a user profile service to provide necessary info
  // eg:
  // userProfile = signal({
  //   fullName: 'Smith, Robert',
  //   email: 'robert.smith@partena.be'
  // });

  private activatedRouter = inject(ActivatedRoute);
  private downloadService = inject(EpgDownloadService);
  private downloadCenterService = inject(EpgDownloadCenterService);
  private location = inject(Location);

  // TODO:  move this to the download center logic
  // private downloadState = signal({
  //   downloading: false,
  //   progress: 0,
  //   error: null,
  //   isComplete: false
  // });

  public isDownloading = computed(
    () => this.downloadCenterService.downloadState().downloading,
  );
  public downloadCompleted = computed(
    () => this.downloadCenterService.downloadState().isCompleted,
  );

  // selectedSubMenu = this.navigationService.selectedSubMenu();

  public backLinkToParentTitle = inject(APP_MENU_BACK_TO_PREVIOUS_TITLE_TOKEN, {
    optional: true,
  });

  public applicationMenuBar = inject(APP_MENU_CONFIG_TOKEN, {
    optional: true,
  }) || [{path: '', label: this.applicationName, alias: this.applicationName}];
  pageLinkTitle: string | null =
    this.navigateToPreviousLabel ?? 'Go back to previous page';

  navigateBack() {
    // return this.navigationService.back();
    return this.location.back();
  }

  onDownload() {
    // this.downloadState.update( state => ({...state,downloading: true, progress: 0, error: null}));

    this.downloadCenterService.downloadState.update((state) => ({
      ...state,
      downloading: true,
      progress: 0,
      error: null,
    }));
    this.downloadService.download();

    // this.downloadService.download().subscribe( event => {
    //   switch(event.type) {
    //     case HttpEventType.DownloadProgress:
    //       // this.downloadState.update( state => ({...state,downloading: true, progress: 0, error: null}));
    //       this.downloadCenterService.downloadState.update( state => ({...state,downloading: true, progress: 0, error: null}));
    //       console.log('Download ' + event.loaded + ' out of ' + event.total + ' bytes');
    //       break;
    //     case HttpEventType.Response:
    //       // this.downloadState.update( state => ({...state,downloading: false, progress: 100, error: null, isComplete: true}));
    //       this.downloadCenterService.downloadState.update( state => ({...state,downloading: false, progress: 0, error: null, isCompleted: true}));
    //       console.log('Finished Downloading!');
    //       break;
    //   }
    // });
  }

  openDownloadedFile() {
    this.downloadCenterService.downloadState.update((state) => ({
      ...state,
      downloading: false,
      progress: 0,
      error: null,
      isComplete: false,
    }));
  }

  private logRouteData(route: ActivatedRoute, parentPath = ''): void {
    const path = parentPath + '/' + route.routeConfig?.path; // Construct full path

    // Recursively log data for child routes
    route.children.forEach((childRoute) => {
      this.logRouteData(childRoute, path);
    });
  }

  prepareRoute(outlet: RouterOutlet) {
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData['animation']
    );
  }

  showBackPageLink() {
    return (
      this.navigateToPreviousPage ||
      this.activatedRouter.snapshot?.firstChild?.data['navigateToPreviousPage']
    );
  }
}
